import { render, staticRenderFns } from "./course_discuss_area.vue?vue&type=template&id=397fdba0&scoped=true"
import script from "./course_discuss_area.vue?vue&type=script&lang=js"
export * from "./course_discuss_area.vue?vue&type=script&lang=js"
import style0 from "./course_discuss_area.vue?vue&type=style&index=0&id=397fdba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fdba0",
  null
  
)

export default component.exports